<!-- static content data from lang: patient_list -->
<template>
    <div class="container">
        <div class="my-3" v-loading="loading" >
            <b-card class="patient-listing">
                    <div class="row">
                            <ValidationObserver ref="observer" v-slot="{ passes }">
                            <b-form @submit.stop.prevent="passes(filterData(true))">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="heading-title primary-text">Filter</h6>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-8 input-section">
                                                <div class="row">
                                                
                                                    <div class="col-md-3 col-xl-3 pr-md-0">
                                                        <b-form-group>
                                                            <label class="label-control" for="name">
                                                                Name of Patient:
                                                            </label>
                                                            <div>
                                                                 <multiselect
                                                            v-model="models.patientName"
                                                            :options="patientNameList"
                                                            @input="onNameChange"
                                                            :preserve-search="false" 
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            label="name"
                                                            :custom-label="customLabel"
                                                            placeholder="Select Patient"
                                                            :taggable="true" 
                                                            @tag="addTag"
                                                            tag-placeholder="Search Patient"  
                                                            track-by="name"  
                                                            :preselect-first="true"
                                                            >
                                                                
                                                            <template slot="singleLabel" slot-scope="props">
                                                                <span class="option__title">{{ props.option.name }}</span>
                                                            </template>
                                                            <template slot="option" slot-scope="props" v-if="props.option.name && (props.option.email || props.option.mobile)">
                                                                <div class="option__desc"><span class="option__title">{{ props.option.name }}</span><br/><span class="option__small">{{ props.option.mobile }}</span><br/><span class="option__small">{{ props.option.email }}</span></div>
                                                            </template>
                                                        </multiselect>

                                                                <!--<span class="text-danger">{{ validationContext.errors[0] }}</span>-->
                                                            </div>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-3 col-xl-3 pr-md-0">
                                                        <label class="label-control" for="idNumber">
                                                            Id Number of Patient:                                                            
                                                        </label>
                                                        <div>
                                                            <multiselect
                                                                v-model="models.idNumber"
                                                                :options="patientNameList"
                                                                @input="onIdChange"
                                                                :searchable="true"
                                                                :close-on-select="true"
                                                                :show-labels="false"
                                                                label="idNumber"
                                                                :custom-label="customLabel1"
                                                                placeholder="Select Patient Id" >

                                                                <template slot="singleLabel" slot-scope="props"><span class="option__title">{{ props.option.patientId }}</span></template>
                                                                <template slot="option" slot-scope="props">
                                                                    <div class="option__desc"><span class="option__title">{{ props.option.patientId }}</span><br/><span class="option__small">{{ props.option.name }}</span></div>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-9 col-xl-6 pr-md-0">
                                                        <div class="row inputs">
                                                            <div class="col-md-3 col-xl-4">
                                                                <b-form-group>
                                                                    <label class="label-control" for="from">Date From:</label>
                                                                    <el-date-picker
                                                                        v-model="models.dateFrom"
                                                                        type="date"
                                                                        format="dd/MM/yyyy"
                                                                        id="dateFrom"
                                                                        :change="focus"
                                                                        :picker-options="dateFromOptions"
                                                                        placeholder="DD/MM/YY"
                                                                        ></el-date-picker>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-md-3 col-xl-4">
                                                                <b-form-group>
                                                                    <label class="label-control" for="to">Date To:</label>
                                                                    <el-date-picker
                                                                        v-model="models.dateTo"
                                                                        type="date"
                                                                        format="dd/MM/yyyy"
                                                                        id="dateTo"
                                                                        :picker-options="dateToOptions"
                                                                        placeholder="DD/MM/YY"
                                                                        ></el-date-picker>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-md-3 col-xl-4">
                                                                <b-form-group>
                                                                    <label class="label-control" for="to">Date Of Birth:</label>
                                                                    <el-date-picker
                                                                        v-model="models.dob"
                                                                        type="date"
	                                                                    format="yyyy/MM/dd"
                                                                        id="dateDOB"
                                                                        placeholder="DD/MM/YY"
                                                                        ></el-date-picker>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-xl-6">
                                                        <b-form-group>
                                                            <label class="label-control" for="status">Status:</label>
                                                            <b-form-checkbox-group
                                                            v-model="models.status"
                                                            :options="status"
                                                            text-field="name"
                                                            value-field="item"
                                                            class="mt-3 pt-1"
                                                            ></b-form-checkbox-group>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-4 button-section pl-lg-0 align-self-center">
                                                        <b-form-group class="mb-0">
                                                            <b-btn type="submit" variant="secondary" class="mr-2"  >Filter</b-btn>

                                                            <b-btn type="button" variant="secondary" @click="resetData()">Reset</b-btn>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                </div>
                
                <hr class="mx--body my-0" />
                <div class="row">
                    <!-- <template v-if="errored"> {{lang.label.error}}</template> -->
                    <template>
                        <template v-if="data.length > 0">
                            <div class="col-md-6 col-lg-4" v-for="(patient, index) in data" :key="index">
                                <a href="javascript:void(0)" @click="groupRequestDetails(patient)">
                                <b-card class="shadow-none" body-class="p-3">
                                    <div class="row">
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.name}}:</span>
                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.patientName!=''? patient.patientName :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5">
                                            <span class="mb-2 d-block">{{lang.label.phoneNumber}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.mobile!=''? patient.mobile :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5" >
                                            <span class="mb-2 d-block">{{lang.label.emailId}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{(patient.email!=''? patient.email :lang.label.nodata)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5" >
                                            <span class="mb-2 d-block">{{lang.label.receivedDate}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{formatDate(patient.createdAt)}}</span>

                                        </div>
                                        <div class="col-6 col-lg-5" >
                                            <span class="mb-2 d-block">{{lang.label.sentDate}}:</span>

                                        </div>
                                        <div class="col-6 col-lg-7">
                                            <span class="mb-2 d-block">{{formatDate(patient.generatedAt)}}</span>
                                            <!--&nbsp;
                                            <span v-if="patient.status == 3" style="color: red">{{lang.label.rejected}}</span>-->
                                        </div>
                                        <div class="col-6 col-lg-5" >
                                            <span v-if="patient.status == 3" style="color: red">{{lang.label.rejected}}</span>

                                        </div>
                                    </div>
                                </b-card>
                                </a>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 text-center pt-3">{{lang.label.noDataFound}}</div>
                        </template>
                    </template>
                </div>
            </b-card>
        </div>
        <div v-observe-visibility="visibilityChanged">
        </div>
    </div>
</template>

<script>
    import jsondata from "../assets/json/data.json";
    var moment = require('moment'); // require
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import Vue from "vue";
    import VueObserveVisibility from 'vue-observe-visibility'
    Vue.use(VueObserveVisibility)

    export default {
        components: {
            Multiselect
        },
        computed: {
            ...mapGetters({
                loading: "loading",
                fromGroupRequests:"fromGroupRequests"
            }),
            dateFrom() {
                return this.models.dateFrom;
            },
            dateTo() {
                return this.models.dateTo;
            }
        },
                    data() {
            return {
                data: [],
                lang: this.$lang.group_request_list,
                errored: false,
                models: {
                    patientName: '',
                    dateFrom: '',
                    dateTo: '',
                    status: [],
                    idNumber:'',
                     dob:"",
                },
                status: [
                    {item: "1", name: "Paid"},
                    {item: "0", name: "Unpaid"}
                ],
                disablingFromDate: '',
                disablingToDate: '',
                
                dateFromOptions: {
                    disabledDate: this.disableFromDate
                },
                dateToOptions: {
                    disabledDate: this.disableToDate
                },
                patientNameList: [],
                currentPageFilNull: 1,
                currentPageFil: 1,
                filtered: false,
                allLoaded:false,
                allLoadedFil: false,
            };
        },
        mounted() {
            this.$store.dispatch('getPatientDetails').then(response => {
                if (response.data) {
                    response.data.forEach((object, index) => {
                        if (object.name) {
                            this.patientNameList.push({id: object.id, name: object.name, mobile: object.mobile, patientId: object.idNumber,email:object.email});
                        }
                    });
                }
            });
            this.getApiData();
            // this.setPatientData();
            // window.addEventListener('scroll', this.scroll, false);
        },
        methods: {
            addTag(query){
                    this.models.idNumber='';
                    console.log("query",query);
                    this.patientNameList.push({"name":query,"email":"","mobile":""});
                    // console.log(this.patientNameList)

                    let last_elem=this.patientNameList[this.patientNameList.length-1];   // storing last elem of ana array
                    // console.log(last_elem)
                    this.models.patientName=last_elem;
                    console.log(this.models.patientName.name);  
                    // this.getApiData(1,true,this.models.patientName.name);
            },
            onNameChange() {
                this.models.idNumber = this.models.patientName;
            },
            onIdChange() {
                this.models.patientName = this.models.idNumber;
            },
            visibilityChanged(){
                // console.log('here', this.allLoaded + ' - ' + this.allLoadedFil);
                if (this.filtered) {
                    if(!this.allLoadedFil){
                        this.getApiData(1);
                    }
                } else {
                    if (!this.allLoaded && !this.loading) {
                        this.getApiData();
                    }
                }
            },
            formatDate(date) {
                return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : this.lang.label.nodata;
            },
            formatAddress(address){
                return address.replace(/\n/g, '<br/>');
            },
            formatDob(date) {
                return moment(date).format('DD/MM/YYYY');
            },
	        groupRequestDetails(data) {
            	// return;
                this.$store.commit('setGroupRequestDetails',data);
		        this.$router.push({ name: 'past-request-details' });
            },
            formatGender(value) {
                if (value === 1)
                {
                    return this.lang.label.male;
                } else if (value === 2) {
                    return this.lang.label.female;
                } else if (value === 3) {
                    return this.lang.label.other;
                } else {
                    return this.lang.label.nodata;
                }
            },
            disableFromDate(date) {
                if (this.models.dateTo != null && this.models.dateTo != '') {
                    return (date > Date.now() || date > this.models.dateTo);
                } else {
                    return (date > Date.now());
                }
            },
            disableToDate(date) {

                return (date < this.models.dateFrom || date > Date.now());
            },
            customLabel( { name, mobile,email }) {
                return `${name} ${mobile} ${email}`;
            },
            customLabel1( { patientId, name }) {
                return `${patientId} ${name}`;
            },
            focus() {
                // alert()
            },
            filterData(flag) {
                this.$store.commit('setLoading', true);
                this.allLoadedFil = false;
                if (flag) {
                this.getApiData(1, true);
                this.filtered = true;
                } else {
                    this.getApiData(1);
                }
            },
            getApiData(applyFilter = 0, flag) {
                this.$store.commit('setLoading', true);
                let data = {};
                if (applyFilter == 0) {
                    if (flag) {
                        this.data = [];
                        this.currentPageFilNull = 1;
                    }
                    data = {
                        "status": 3,
                        "patientId": "",
                        "fromDate": "",
                        "toDate": "",
                        "idNumber":"",
                        "pageNo": this.currentPageFilNull,
                        "birthDate":""
                    };
                    this.currentPageFilNull = this.currentPageFilNull + 1;
                } else {

                    var statusdata = this.models.status;
                    var status = '';
                    if (statusdata.length === 1)
                    {
                        status = this.models.status[0];
                    }
                    if (flag) {
                        this.data = [];
                        this.currentPageFil = 1;
                    }
                    data = {
                        "status": status ? status : 3,
                        "patientName": (this.models.patientName != null) ? this.models.patientName.name : 0,
                        "fromDate": (this.models.dateFrom != null && this.models.dateFrom != "") ? moment(this.models.dateFrom).format("YYYY-MM-DD") : "",
                        "toDate": (this.models.dateTo != null && this.models.dateTo != "") ? moment(this.models.dateTo).format("YYYY-MM-DD") : "",
                        "idNumber":(this.models.idNumber != null) ? this.models.idNumber.patientId : "",
                        "pageNo": this.currentPageFil,
                        "birthDate" : (this.models.dob!=null && this.models.dob!="")? moment(this.models.dob).format("YYYY-MM-DD"):"",
                   };
                   this.currentPageFil = this.currentPageFil + 1;
                }
                this.$store.dispatch('getGroupRequestList', data).then(async response => {
                    if (response.length > 0) {
                        this.data = this.data.concat(response);
                        // this.data=await this.data.sort((a, b) => (b.formsManagementId) - (a.formsManagementId));

                    } else if (data['patientId'] == '') {
                        this.allLoaded = true;
                        this.allLoadedFil = false;
                    } else {
                        this.allLoaded = false;
                        this.allLoadedFil = true;
                    }
                    this.$store.commit('setLoading', false);
                }).catch(error => {
                    this.errored = true;
                }).finally(() => this.$store.commit('setLoading', false))
            },
            setPatientData(){
                if(this.fromGroupRequests)
                {
                //  this.models.patientName= this.patientInfo.patientId;
                    // var patientName;
                    // var self = this;
                    // this.patientNameList.map((obj) => {
                    //     console.log('obj',obj);
                    //     if (obj.id == self.patientInfo.patientId) {
                    //         patientName = obj;
                    //     }
                    //     return true;
                    // })
                    // console.log('name', patientName);
                    this.models.patientName= { "id": this.patientInfo.patientId, "name": this.patientInfo.patientName, "mobile": this.patientInfo.mobile };
                    this.models.idNumber=this.patientInfo.idNumber;
                    // function call
                    this.filterData();
                }
             
            },
            scroll () {
                window.onscroll = () => {
                    let bottomOfWindow = document.documentElement.scrollHeight - document.documentElement.scrollTop === document.documentElement.clientHeight;
                    if (bottomOfWindow) {
                        //  this.scrolledToBottom = true // replace it with your code
                        // console.log('Page End');
                        if (this.filtered) {
                            this.getApiData(1);
                        } else {
                            this.getApiData();
                        }
                    }
                }
            },
            resetData() {
                this.$store.commit('setLoading', true);
                this.models.status = [];
                this.models.patientName = null;
                this.models.dateFrom = '';
                this.models.dateTo = '';
                this.models.dob='';
                this.models.idNumber='';
                this.getApiData(0, true);
                this.$nextTick(() => {
                    this.$refs.observer.reset();
                });
            },
        }
    };
</script>